module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-starts-2-large-980cf506e0f288a80fc054448763778b.jpg";